import { create } from "zustand";

type State = {
  openModalCount: number;
  registerOpenModal: () => void;
  unregisterOpenModal: () => void;
};

// Global count of currently-open overlays that take the keyboard — the shared <Modal>, and the click-owned rack cards and popovers that replaced modals in TTV. Every one of them registers through useRegisterOpenOverlay while it is shown, so document-level keyboard shortcuts (e.g. the TTV piano-roll delete/undo/space keys) can disable themselves and not act on the content behind the open surface. A count (not a boolean) tolerates more than one overlay being mounted open at once.
export const useOpenModalCount = create<State>()((set) => ({
  openModalCount: 0,
  registerOpenModal: () =>
    set((state) => ({ openModalCount: state.openModalCount + 1 })),
  unregisterOpenModal: () =>
    set((state) => ({ openModalCount: Math.max(0, state.openModalCount - 1) })),
}));
